<div class="layout-topbar">
  <div class="layout-topbar-wrapper">
    <div class="layout-topbar-left">
      <div class="layout-topbar-logo" id="logolink" style="cursor: pointer; outline: none;" routerLink="/">
        <img id="app-logo"
          src="{{image}}"
          alt="company logo">
      </div>
    </div>

    <div class="layout-topbar-right">
      <a class="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
      </a>

      <ul class="layout-topbar-actions">
        <li #settings class="topbar-item settings"
          [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === settings}">
          <a href="#" (click)="appMain.onTopbarItemClick($event,settings)">
            <span class="topbar-icon">
              <i class="pi pi-cog"></i>
            </span>
          </a>
          <ul class="fadeInDown">
            <li class="layout-submenu-header">
              <h6 class="header-text">Settings</h6>
            </li>
            <li role="menuitem">
              <a href="#" (click)="appMain.onTopbarSubItemClick($event, 'account-info')">
                <i class="pi pi-user"></i>
                <div class="settings-item">
                  <h6>Account Settings</h6>
                </div>
              </a>
            </li>
          </ul>
        </li>
        <li #profile class="topbar-item user-profile"
          [ngClass]="{'active-topmenuitem':appMain.activeTopbarItem === profile}">
          <a href="#" (click)="appMain.onTopbarItemClick($event,profile)">
            <!--  <img class="profile-image" src="assets/layout/images/avatar-profile.png" alt="demo"> -->
            <div class="profile-info">
              <h6>{{user?.username}}</h6>
              <span>{{user?.role}}</span>
            </div>
          </a>

          <ul class="fadeInDown">
            <li role="menuitem">
              <a href="#" (click)="appMain.onTopbarSubItemClick($event, 'logout')">
                <i class="pi pi-power-off"></i>
                <h6>Logout</h6>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
